import React, { useMemo } from 'react';
import SectionRenderer from './SectionRenderer';
import './Grid.css';
import usePrefetchInitialData from 'hooks/usePrefetchInitialData';
import validateConfig from './validateConfig';

function clampWidth(width, maxColumns) {
    if (typeof width !== 'number' || width < 1) return 1;
    if (width > maxColumns) return maxColumns;
    return width;
}

export default function GridRenderer({ config }) {
    const maxColumns = config?.maxColumns || 1;
    const sections = config?.sections || [];
    // Prefetch unique initial data for all sections once
    usePrefetchInitialData(config);

    // Non-intrusive validation in dev/runtime to aid authors
    React.useEffect(() => {
        try {
            const { warnings } = validateConfig(config || {});
            if (Array.isArray(warnings) && warnings.length) {
                // eslint-disable-next-line no-console
                console.warn('[DashboardNew] layoutConfig warnings:', warnings);
            }
        } catch (_) {
            // noop
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const gridStyle = useMemo(() => ({
        gridTemplateColumns: `repeat(${maxColumns}, minmax(0, 1fr))`,
    }), [maxColumns]);

    if (!sections.length) {
        return (
            <div className="dashboard-new-empty">
                <span>Dashboard is empty.</span>
            </div>
        );
    }

    return (
        <div className="dashboard-new-grid" style={gridStyle}>
            {sections.map((section, idx) => {
                const colSpan = clampWidth(section?.width, maxColumns);
                const rowSpan = section?.rowSpan || 1;

                const key = section?.id ? `${section.id}-${idx}` : `section-${idx}`;
                return (
                    // <div key={key} style={{ gridColumn: `span ${colSpan} / span ${colSpan}` }}>
                        <div key={key} style={{ gridColumn: `span ${colSpan} / span ${colSpan}`, gridRow: `span ${rowSpan} / span ${rowSpan}` }}>
                        <SectionRenderer section={section} />
                    </div>
                );
            })}
        </div>
    );
}


